export function VeraAvatar({ level = 0, speaking = false, size = 96 }) {
  const open = speaking ? 1.5 + Math.min(1, level * 3) * 9 : 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" className={`vera ${speaking ? "vera-speaking" : ""}`} data-testid="tour-avatar" aria-label="Vera, your GrantVerify guide">
      <defs>
        <linearGradient id="vera-hair" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stopColor="#1e293b" /><stop offset="1" stopColor="#0f172a" /></linearGradient>
      </defs>
      <circle cx="60" cy="60" r="58" fill="#ecfdf5" stroke="#059669" strokeWidth="3" />
      <g className="vera-body">
        <path d="M22 118c4-22 18-32 38-32s34 10 38 32z" fill="#059669" />
        <path d="M48 88l12 14 12-14" fill="#fff" />
        <circle cx="60" cy="104" r="5" fill="#f59e0b" />
        <rect x="52" y="74" width="16" height="16" rx="6" fill="#f2c4a0" />
        <g className="vera-head">
          <path d="M30 54c0-22 13-34 30-34s30 12 30 34c0 8-2 22-6 30H36c-4-8-6-22-6-30z" fill="url(#vera-hair)" />
          <ellipse cx="60" cy="56" rx="22" ry="25" fill="#f8d3b4" />
          <path d="M37 48c6-14 18-18 30-16 8 1 14 6 16 14-10-4-22-2-30-8-4 5-10 8-16 10z" fill="url(#vera-hair)" />
          <g className="vera-eyes">
            <ellipse cx="51" cy="56" rx="2.8" ry="3.4" fill="#0f172a" />
            <ellipse cx="69" cy="56" rx="2.8" ry="3.4" fill="#0f172a" />
            <circle cx="52" cy="55" r="0.9" fill="#fff" />
            <circle cx="70" cy="55" r="0.9" fill="#fff" />
          </g>
          <path d="M46 49q5-3 10 0M64 49q5-3 10 0" stroke="#0f172a" strokeWidth="1.6" fill="none" strokeLinecap="round" />
          <circle cx="45" cy="64" r="3.5" fill="#fb7185" opacity="0.25" />
          <circle cx="75" cy="64" r="3.5" fill="#fb7185" opacity="0.25" />
          <ellipse cx="60" cy="69" rx="6" ry={open} fill="#9f1239" style={{ transition: "ry 60ms linear" }} />
          {!speaking && <path d="M54 68q6 5 12 0" stroke="#9f1239" strokeWidth="2" fill="none" strokeLinecap="round" />}
        </g>
      </g>
    </svg>
  );
}
